import { createUseStyles } from 'react-jss';
import { Theme } from '@mui/material';

export const useStyles = createUseStyles((theme: Theme) => {
    const { color, radius, mq, font } = theme.custom;
    return {
        grid: {
            display: 'grid',
            gridTemplateColumns: 'minmax(0, 1fr) 340px',
            gap: 20,
            alignItems: 'start',
            [mq.md]: { gridTemplateColumns: 'minmax(0, 1fr) 300px' },
            [mq.sm]: { gridTemplateColumns: 'minmax(0, 1fr)', gap: 16 },
        },
        main: { display: 'flex', flexDirection: 'column', gap: 20, minWidth: 0, [mq.sm]: { gap: 16 } },
        side: { display: 'flex', flexDirection: 'column', gap: 20, minWidth: 0, [mq.sm]: { gap: 16, order: -1 } },
        scroll: { overflowX: 'auto', WebkitOverflowScrolling: 'touch' },
        mono: { fontFamily: font.mono, fontSize: 13, whiteSpace: 'nowrap' },
        secondary: { fontSize: 12, color: color.text.secondary, marginTop: 2 },
        capitalize: { textTransform: 'capitalize' },
        numeric: { textAlign: 'right', fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' },
        productCell: { minWidth: 260 },
        product: { fontWeight: 600, overflowWrap: 'anywhere' },
        nowrap: { whiteSpace: 'nowrap' },
        filesCell: { minWidth: 170 },
        thumb: {
            display: 'block',
            width: 56,
            height: 56,
            borderRadius: radius.sm,
            objectFit: 'cover',
            backgroundColor: color.surfaceMuted,
            outline: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'}`,
            outlineOffset: -1,
        },
        noThumb: {
            width: 56,
            height: 56,
            borderRadius: radius.sm,
            backgroundColor: color.surfaceMuted,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 10,
            color: color.text.muted,
        },
        preview: { display: 'block', maxWidth: 320, maxHeight: 320, borderRadius: radius.sm },
        files: { display: 'flex', flexDirection: 'column', gap: 4, fontSize: 12 },
        fileRow: { display: 'flex', alignItems: 'center', gap: 8, whiteSpace: 'nowrap' },
        fileLink: { color: color.primary.main, fontWeight: 500, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } },
        fileSide: { color: color.text.secondary },
        address: { margin: 0, fontStyle: 'normal', lineHeight: 1.6, fontSize: 14, '& b': { fontWeight: 600 } },
        tags: { display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 12 },
        note: { margin: 0, fontSize: 14, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' },
        totals: { display: 'flex', flexDirection: 'column', gap: 6 },
        totalRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 12, fontSize: 14, color: color.text.secondary },
        totalValue: { fontVariantNumeric: 'tabular-nums', color: color.text.primary, fontWeight: 500 },
        grandTotal: {
            borderTop: `1px solid ${color.border}`,
            paddingTop: 8,
            color: color.text.primary,
            fontWeight: 600,
            '& $totalValue': { fontSize: 18, fontWeight: 600 },
        },
        summaryBody: { padding: '14px 16px 12px' },
        skeletons: { display: 'grid', gap: 16 },
    };
});
